import {
    FETCH_EVENTS,
    FETCH_EVENTS_FAIL,
    FETCH_EVENTS_SUCCESS,
    RESET_EVENTS
} from './actionTypes';

export const fetchEvents = args => ({
    type: FETCH_EVENTS,
    payload: args
});

export const fetchEventsSuccess = response => ({
    type: FETCH_EVENTS_SUCCESS,
    payload: response
});

export const fetchEventsFail = error => ({
    type: FETCH_EVENTS_FAIL,
    payload: error
});

export const resetEvents = () => ({
    type: RESET_EVENTS
});
